import { eventBus } from 'EventBus/';
import { pushEvent } from '../../utils/datalayer';

const NAVIGATION = '.vch-header-nav';
const NAV_PANELS = '.vch-header-nav__category-panel';

const BURGER_BTN = 'NavBurger';
const STORE_LOCATOR_BTN = 'NavStoreLocator';
const MY_ACCOUNT_BTN = 'NavMyAccount';
const SEARCH_BTN = 'NavSearch';

const NAV_BUTTONS = 'button.vch-header-nav__nav-button';
const PANEL_CATEGORY = '--category';
const PANEL_SUBCATEGORY = '--sub-category';
const SEARCH_PANEL = '.vch-header-search';
const SEARCH_INPUT = '#nav-search-query';

const ARIA_EXPANDED = 'aria-expanded';
const ARIA_HIDDEN = 'aria-hidden';

const OPEN_NAV = 'headernav::openNav';
const TOGGLE_PANEL = 'headernav::togglePanel';
const TOGGLE_SEARCH = 'headernav::toggleSearch';

const SEARCH_ICON_HREF = '/assets/sprite/icons.svg#search';
const CLOSE_ICON_HREF = '/assets/sprite/icons.svg#close-overlay';

const OPEN = '--open';
const CLOSING = '--closing';
const ACTIVE = '--active';
const BODY = 'body';

const DEFAULT_SEARCH_OPEN_LABEL = 'Search';
const DEFAULT_SEARCH_CLOSED_LABEL = 'Close (X)';

const tabletMediaQuery = '(min-width: 1024px)';

const emitEvent = (type, index = null) => {
  eventBus.$emit(type, index);
};

const openMenu = (fromBurger = false) => {
  // Close Search Menu if it's open
  if (document.querySelector(SEARCH_PANEL)?.classList.contains(OPEN)) {
    toggleSearchClosed();
  }
  if (document.querySelector(NAVIGATION)?.classList.contains(OPEN)) {
    return;
  }
  document.querySelector(BODY)?.classList.add('navOpen');
  if (fromBurger) {
    document.querySelector(NAVIGATION)?.classList.add(OPEN, ACTIVE);
  } else {
    document.querySelector(NAVIGATION)?.classList.add(OPEN);
  }
  document.getElementById(BURGER_BTN)?.setAttribute(ARIA_EXPANDED, true);
    var element = document.getElementsByClassName('languageselector-wrapper');
    if (ARIA_EXPANDED, true) {
      for(var i = 0; i < element.length; i++)
      {
          element[i].classList.add('languageselector-wrapper-mobile');
      }
    }
      
 
  document.querySelector('main')?.setAttribute(ARIA_HIDDEN, true);
  document.querySelector('footer')?.setAttribute(ARIA_HIDDEN, true);
  emitEvent(OPEN_NAV, { status: true, fromBurger });
};

const deactivatePanels = (subcatOnly = false) => {
  const deactivateElement = (el) => {
    if (el.tagName === 'BUTTON') {
      el?.setAttribute(ARIA_EXPANDED, false);
    } else {
      el?.classList.remove(ACTIVE);
    }
  };

  if (!subcatOnly) {
    const catEls = document.querySelectorAll(`.${PANEL_CATEGORY}`);
    catEls.forEach(deactivateElement);
  }

  const subCatEls = document.querySelectorAll(`.${PANEL_SUBCATEGORY}`);
  subCatEls.forEach(deactivateElement);
};

const closeMenu = () => {
  // Menu is already open
  document.querySelector(BODY)?.classList.remove('navOpen');
  var element = document.getElementsByClassName('languageselector-wrapper');
    for(var j = 0; j < element.length; j++)
    {
        element[j].classList.remove('languageselector-wrapper-mobile');
    }
  // Mobile gets a timeout for it to slide shut before deactivating the content
  const closeTimeout = window.matchMedia(tabletMediaQuery).matches ? 0 : 300;
  document.querySelector(NAVIGATION)?.classList.remove(OPEN);
  document.querySelector(NAVIGATION)?.classList.add(CLOSING);
  document.getElementById(BURGER_BTN)?.setAttribute(ARIA_EXPANDED, false);
  setTimeout(() => {
    document.querySelector(NAVIGATION)?.classList.remove(ACTIVE);
    document.querySelector(NAVIGATION)?.classList.remove(CLOSING);
    // Remove Open/Current Modifiers
    const panels = document.querySelectorAll(NAV_PANELS);
    panels.forEach((p) => p?.classList.remove(ACTIVE));

    const navButtons = document.querySelectorAll(NAV_BUTTONS);
    navButtons.forEach((b) => b?.setAttribute(ARIA_EXPANDED, false));

    document.querySelector('main')?.removeAttribute(ARIA_HIDDEN);
    document.querySelector('footer')?.removeAttribute(ARIA_HIDDEN);
    emitEvent(OPEN_NAV, { status: false, fromBurger: false });
  }, closeTimeout);
};

const togglePanelClosed = (trigger, target) => {
  if (target && document.querySelector(`#${target}.${ACTIVE}`)) {
    document.querySelector(`#${target}`)?.classList.remove(ACTIVE);
    trigger?.setAttribute(ARIA_EXPANDED, false);
    emitEvent(TOGGLE_PANEL, target);
    
    var element = document.getElementsByClassName('languageselector-wrapper');
    if (ARIA_EXPANDED, true) {
      for(var i = 0; i < element.length; i++)
      {
          element[i].classList.add('languageselector-wrapper-mobile');
      }
    }
  const categoryPanel = document.querySelector('.vch-header-nav__category-panel');
  if (categoryPanel?.classList.contains('--active')) {
    var element = document.getElementsByClassName('languageselector-wrapper');
    for (var i = 0; i < element.length; i++) {
      element[i].classList.remove('languageselector-wrapper-mobile');
    }
  }
  }
};

const togglePanelOpen = (trigger, target) => {
  // No need to call focus event
  //trigger.focus();
  if (target && !document.querySelector(`#${target}.${ACTIVE}`)) {
    var element = document.getElementsByClassName('languageselector-wrapper');
    for (var i = 0; i < element.length; i++) {
      element[i].classList.remove('languageselector-wrapper-mobile');
    }
    openMenu();

    // Deactivate sibling panels
    if (trigger?.classList.contains(PANEL_CATEGORY)) {
      deactivatePanels(false);
    }
    if (trigger?.classList.contains(PANEL_SUBCATEGORY)) {
      deactivatePanels(true);
    }

    document.querySelector(`#${target}`)?.classList.add(ACTIVE);
    trigger?.setAttribute(ARIA_EXPANDED, true);
    emitEvent(TOGGLE_PANEL, target);
    
  }
};

const toggleSearchClosed = () => {
  const searchButton = document.getElementById(SEARCH_BTN);
  searchButton?.setAttribute(ARIA_EXPANDED, false);
  searchButton?.querySelector('svg>use').setAttribute('href', SEARCH_ICON_HREF);

  const openLabel =
    searchButton.getAttribute('data-open-label') || DEFAULT_SEARCH_OPEN_LABEL;
  searchButton?.querySelector('svg')?.setAttribute('aria-label', openLabel);

  document.getElementById(STORE_LOCATOR_BTN)?.removeAttribute('tabindex');
  document.getElementById(MY_ACCOUNT_BTN)?.removeAttribute('tabindex');
  document.querySelector(SEARCH_PANEL)?.classList.remove(OPEN);
  emitEvent(TOGGLE_SEARCH, { status: false });
};

const toggleSearchPanel = () => {
  const searchPanel = document.querySelector(SEARCH_PANEL);
  const searchInput = document.querySelector(SEARCH_INPUT);
  if (searchInput) searchInput.value = '';
  if (!searchPanel?.classList.contains(OPEN)) {
    // Check if nav is open, and close it if needed
    if (document.querySelector(NAVIGATION)?.classList.contains(OPEN)) {
      closeMenu();
    }
    // Open Search Panel
    const searchButton = document.getElementById(SEARCH_BTN);
    searchButton?.setAttribute(ARIA_EXPANDED, true);
    const closeLabel =
      searchButton.getAttribute('data-close-label') ||
      DEFAULT_SEARCH_CLOSED_LABEL;
    searchButton?.querySelector('svg')?.setAttribute('aria-label', closeLabel);
    searchButton
      ?.querySelector('svg>use')
      .setAttribute('href', CLOSE_ICON_HREF);

    document.getElementById(STORE_LOCATOR_BTN)?.setAttribute('tabindex', '-1');
    document.getElementById(MY_ACCOUNT_BTN)?.setAttribute('tabindex', '-1');

    pushEvent({
      event: 'uaevent',
      eventCategory: 'main menu navigation',
      eventAction: 'select::header',
      eventLabel: 'search',
      event_name: 'internal_search_click',
      click_area: 'header',
    });

    searchPanel?.classList.add(OPEN);
    searchInput.focus();
    emitEvent(TOGGLE_SEARCH, { status: true });
  } else {
    toggleSearchClosed();
  }
};

const headerNav = {
  name: 'headernav',
  inserted: (el, binding) => {
    const { arg, value } = binding;

    switch (arg) {
      case 'burger':
        el.addEventListener('click', () => {
          openMenu(true);
        });
        break;

      case 'paneltoggle':
        el.addEventListener('click', () => {
          togglePanelOpen(el, value ? value.id : undefined);
        });
        el.addEventListener('mouseenter', () => {
          if (window.matchMedia(tabletMediaQuery).matches) {
            togglePanelOpen(el, value ? value.id : undefined);
          }
        });
        break;

      case 'backreturn':
        el.addEventListener('click', () => {
          togglePanelClosed(el, value ? value.id : undefined);
        });
        break;

      case 'menuclose':
        el.addEventListener('click', () => {
          closeMenu();
        });
        el.addEventListener('mouseenter', () => {
          if (window.matchMedia(tabletMediaQuery).matches && value) {
            closeMenu();
          }
        });

        break;

      case 'menuleave':
        el.addEventListener('mouseenter', () => {
          closeMenu();
        });
        break;

      case 'searchtoggle':
        el.addEventListener('click', () => {
          toggleSearchPanel();
        });
        break;

      case 'searchclose':
        el.addEventListener('click', () => {
          toggleSearchClosed();
        });
        break;

      default:
        break;
    }
  },
};

export {
  headerNav,
  emitEvent,
  openMenu,
  deactivatePanels,
  closeMenu,
  togglePanelClosed,
  togglePanelOpen,
  toggleSearchClosed,
  toggleSearchPanel,
};
